import { generateTypes } from '../utils/HttpReducerHelper';

export const postcoderAddress = generateTypes('POSTCODER', 'ADDRESS');
export const postcoderSearch = generateTypes('POSTCODER', 'SEARCH');
export const postcoderResetSearch = 'platfi-ui-app/POSTCODER/RESET_SEARCH';
